// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3SWnP","head":"Table_head__Of_m3","col":"Table_col__2Yvue"};